/* eslint-disable no-unused-vars */
import React from 'react';
import { motion } from 'framer-motion';
import { 
  ShieldCheckIcon, 
  DocumentTextIcon, 
  ScaleIcon, 
  ExclamationTriangleIcon,
  GlobeAltIcon,
  UserGroupIcon
} from '@heroicons/react/24/outline';
import Footersection from '../views/Home/Footersection';
import Navbarsection from '../views/Home/Navbarsection';

export default function TermsAndConditions() {
  const sections = [
    {
      icon: <DocumentTextIcon className="w-6 h-6" />,
      title: "Agreement to Terms",
      content: "By accessing mahakalsocialwelfaresociety.in, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not access our services or website."
    },
    {
      icon: <UserGroupIcon className="w-6 h-6" />,
      title: "User Conduct",
      content: "Users are prohibited from using this site for any unlawful purpose. You must not transmit any worms, viruses, or any code of a destructive nature. Any behavior that restricts or inhibits others from using the site is strictly prohibited."
    },
    {
      icon: <ScaleIcon className="w-6 h-6" />,
      title: "Intellectual Property",
      content: "All content, logos, designs, and text on this website are the intellectual property of our organization. You may not reproduce, duplicate, copy, or exploit any portion of the service without express written permission."
    },
    {
      icon: <GlobeAltIcon className="w-6 h-6" />,
      title: "Third-Party Links",
      content: "Our website may contain links to third-party sites that are not owned or controlled by us. We assume no responsibility for the content, privacy policies, or practices of any third-party websites."
    },
    {
      icon: <ExclamationTriangleIcon className="w-6 h-6" />,
      title: "Limitation of Liability",
      content: "Our organization shall not be held liable for any damages that result from the use of, or the inability to use, the materials on this site or the performance of the products or services."
    },
    {
      icon: <ShieldCheckIcon className="w-6 h-6" />,
      title: "Governing Law",
      content: "These terms shall be governed by and defined following the laws of our jurisdiction. You irrevocably consent that the courts shall have exclusive jurisdiction to resolve any dispute which may arise."
    }
  ];

  return (
    <>
    <Navbarsection/>
     <div className="bg-[#FFFAF5] min-h-screen py-20 px-4 selection:bg-orange-100">
      {/* Background Decorative Blurs */}
      <div className="fixed top-0 left-0 w-full h-full overflow-hidden pointer-events-none -z-10">
        <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-orange-200/40 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[400px] h-[400px] bg-orange-100/60 rounded-full blur-[100px]" />
      </div>

      <div className="max-w-4xl mx-auto">
        {/* Header Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-20"
        >
          <div className="inline-block px-4 py-1.5 mb-6 rounded-full bg-orange-100 text-orange-700 text-xs font-black uppercase tracking-[0.2em]">
            Legal Framework
          </div>
          <h1 className="text-5xl md:text-7xl font-black text-gray-900 tracking-tighter mb-6">
            TERMS & <br />
            <span className="text-orange-600">CONDITIONS</span>
          </h1>
          <p className="text-gray-500 font-medium text-lg">
            Last updated: May 2026
          </p>
        </motion.div>

        {/* Content Section */}
        <div className="space-y-8">
          {sections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group relative bg-white/60 backdrop-blur-md border border-orange-50 p-8 rounded-[2rem] hover:shadow-2xl hover:shadow-orange-100/50 transition-all duration-500"
            >
              <div className="flex flex-col md:flex-row gap-6 items-start">
                <div className="flex-shrink-0 w-14 h-14 bg-orange-600 rounded-2xl flex items-center justify-center text-white shadow-lg shadow-orange-200 group-hover:scale-110 transition-transform duration-500">
                  {section.icon}
                </div>
                <div>
                  <h3 className="text-2xl font-black text-gray-900 mb-3 tracking-tight uppercase">
                    {section.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed font-medium">
                    {section.content}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Support Footer */}
        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          className="mt-20 p-10 bg-black rounded-[3rem] text-center text-white relative overflow-hidden"
        >
          <div className="absolute top-0 right-0 w-32 h-32 bg-orange-600/20 rounded-full blur-3xl" />
          <h4 className="text-2xl font-black mb-4 uppercase tracking-tight">Have questions?</h4>
          <p className="text-gray-400 mb-8 max-w-md mx-auto font-medium">
            If you have any queries regarding our terms, please feel free to reach out to our legal department.
          </p>
          <button className="bg-orange-600 hover:bg-orange-500 text-white font-black py-4 px-10 rounded-2xl transition-all active:scale-95 shadow-xl shadow-orange-600/20 uppercase tracking-widest text-sm">
            Contact Legal Team
          </button>
        </motion.div>

        {/* Bottom Decorative Tag */}
        <div className="mt-12 text-center">
            <p className="text-[10px] font-black text-orange-900/30 uppercase tracking-[0.4em]">
              Mahakal Social Welfare Society • All Rights Reserved
            </p>
        </div>
      </div>
    </div>
    <Footersection/>
    </>
   
  );
}